import styled from '@emotion/styled';
import { RuleFormField } from '../../../MerchandisingRules/components/MerchandisingRuleForm/components/RuleFormField/RuleFormField';

export const RuleFormFieldStyled = styled(RuleFormField)`
  margin: 6px 0 32px;
`;
